const formatCurrency = (value = 0) => {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    maximumFractionDigits: 0,
  }).format(Number(value) || 0);
};

const InfoRow = ({ label, value, strong = false }) => (
  <div className="flex items-center justify-between gap-4 py-2 border-b border-slate-100 last:border-b-0">
    <span className="text-sm text-slate-500">{label}</span>
    <span className={`text-sm ${strong ? 'font-semibold text-slate-900' : 'text-slate-700'}`}>
      {value}
    </span>
  </div>
);

const KurangBayarCard = ({ data }) => {
  if (!data) return null;

  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-slate-900">Kurang Bayar</h2>
        <p className="text-sm text-slate-500">
          Ringkasan perhitungan PPh YTD.
        </p>
      </div>

      <div className="grid gap-4 md:grid-cols-3 mb-5">
        <div className="rounded-xl bg-rose-50 border border-rose-100 p-4">
          <p className="text-xs font-medium uppercase tracking-wide text-rose-600">
            Kurang Bayar YTD
          </p>
          <p className="mt-2 text-2xl font-bold text-rose-700">
            {formatCurrency(data.kurang_bayar_ytd)}
          </p>
        </div>

        <div className="rounded-xl bg-emerald-50 border border-emerald-100 p-4">
          <p className="text-xs font-medium uppercase tracking-wide text-emerald-600">
            Lebih Bayar YTD
          </p>
          <p className="mt-2 text-2xl font-bold text-emerald-700">
            {formatCurrency(data.lebih_bayar_ytd)}
          </p>
        </div>

        <div className="rounded-xl bg-sky-50 border border-sky-100 p-4">
          <p className="text-xs font-medium uppercase tracking-wide text-sky-600">
            Tax Due YTD
          </p>
          <p className="mt-2 text-2xl font-bold text-sky-700">
            {formatCurrency(data.tax_due_ytd)}
          </p>
        </div>
      </div>

      <div className="grid gap-6 lg:grid-cols-2">
        <div className="rounded-xl border border-slate-200 p-4">
          <h3 className="mb-3 text-sm font-semibold text-slate-800">
            Data YTD
          </h3>

          <InfoRow label="Taxpayer" value={data.taxpayer_name || '-'} />
          <InfoRow label="Tax Year" value={data.tax_year || '-'} />
          <InfoRow label="Last Month" value={data.last_month || '-'} />
          <InfoRow label="YTD Gross Income" value={formatCurrency(data.ytd_gross_income)} />
          <InfoRow label="YTD Net Income" value={formatCurrency(data.ytd_net_income)} />
          <InfoRow label="YTD Withheld" value={formatCurrency(data.ytd_withheld)} />
        </div>

        <div className="rounded-xl border border-slate-200 p-4">
          <h3 className="mb-3 text-sm font-semibold text-slate-800">
            Tax Calculation
          </h3>

          <InfoRow label="PTKP Status" value={data.ptkp_status || '-'} />
          <InfoRow label="PTKP Amount" value={formatCurrency(data.ptkp_amount)} />
          <InfoRow label="PKP" value={formatCurrency(data.pkp)} />
          <InfoRow label="Estimated Annual Income" value={formatCurrency(data.estimated_annual_income)} />
          <InfoRow label="Estimated Annual Tax" value={formatCurrency(data.estimated_annual_tax)} />
          <InfoRow label="Net Method" value={data.net_method || '-'} strong />
        </div>
      </div>
    </section>
  );
};

export default KurangBayarCard;